import type { MilestoneInput, TaskType } from '@mybusinessmate/schema';

/**
 * The track a new task starts with (Figma A05.3 step 3, A05.4). Editable per task: these are only where the team
 * usually is at each stop. The last stop is always "Ready for client" at 100%.
 */
export const MILESTONE_TEMPLATES: Record<TaskType, MilestoneInput[]> = {
  post: [
    { title: 'Concept & copy', targetProgress: 25 },
    { title: 'Design draft', targetProgress: 60 },
    { title: 'Lead QA', targetProgress: 80 },
    { title: 'Ready for client', targetProgress: 100 },
  ],
  reel: [
    { title: 'Script', targetProgress: 20 },
    { title: 'Footage', targetProgress: 50 },
    { title: 'Edit', targetProgress: 80 },
    { title: 'Ready for client', targetProgress: 100 },
  ],
  website: [
    { title: 'Structure', targetProgress: 20 },
    { title: 'Design', targetProgress: 50 },
    { title: 'Build', targetProgress: 80 },
    { title: 'Ready for client', targetProgress: 100 },
  ],
  monthly_update: [
    { title: 'Changes made', targetProgress: 60 },
    { title: 'Checked', targetProgress: 90 },
    { title: 'Ready for client', targetProgress: 100 },
  ],
  custom: [
    { title: 'Started', targetProgress: 30 },
    { title: 'Ready for review', targetProgress: 80 },
    { title: 'Ready for client', targetProgress: 100 },
  ],
};

/** The stored milestones as the editor and the API take them. */
export const toMilestoneInputs = (
  milestones: { title: string; description: string | null; targetProgress: number; completed: boolean }[],
): MilestoneInput[] =>
  milestones.map((m) => ({
    title: m.title,
    ...(m.description ? { description: m.description } : {}),
    targetProgress: m.targetProgress,
    completed: m.completed,
  }));
